export default {
	page: {
        loading: false
    },
    register: {
        message:'',
        error: '',
        token_hash: '',
        loading: false,
        registered: false
    },
    personalInfo: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        type: '',
        error: '',
        loading: false
    },
    ribbonNotification: {
        visible: 0,
        bg_color: '',
        text_color: ''
    },
    mainUI: {
        header_bg_color: '',
        logo_path: '',
        logo_path_attribute: '',
        main_site_button_text: '',
        main_site_button_color: '',
        main_site_link: '',
        landing_page_image: '',
        banner_image: '',
        banner_gradient_light: '',
        banner_gradient_dark: '',
        button_color: '',
        button_text_color: '',
        breadcrumbs: '',
        calendar_color: ''
    },
    searchInstruction:{
        search_instruction_one: '',
        search_instruction_two: ''
    },
    landingPageContent: {
        login_heading: '',
        login_button_link: '',
        login_content: '',
        registration_heading: '',
        registration_button_link: '',
        registration_content: ''
    },
    footerSettings: {
        contactNumber: '',
        copyrightText: '',
        councilName: '',
        email: '',
        isSecondFooter: '',
        logoPath: '',
        logoPathAttribute: '',
        operatingHours: '',
        footer_links: {
            text: '',
            url: ''
        }
    },
    // paymentAPI: {
    //     merchantCode: '',
    //     customerNumber: ''
    // },
    searchedAddresses: {
        list: [],
        error: '',
        loading: false,
        fetched: false,
    },
    activeAddress: null,
    activeFavorite: null,
    termsCondition: [],
    serviceGroup:{
        list: []
    },
    excludedServicesOfSelectedAddressSetting:{
        list: []
    },
    entitlementDetails: [],
    addressEntitlement: {
        list: []
    },
    registerConfirmation:{
        codeStatus: '',
        message: ''
    },
    resendConfirmationEmail:{
        codeStatus: '',
        message: ''
    },
    websiteMetadata : {
        title : null
    },
    siteWordingsSettings : {},
    streetAbbreviations : {
        list : []
    },
}